import Typography from "../shared/Typography";
import { IoMdClose } from "react-icons/io";
import { Button } from "../shared/Button";
import classNames from "classnames";
import { red_trash_icon } from "assets/svg";
import { useDeleteBlock } from "services";
import { toast } from "react-toastify";
import { customId } from "utils";
import { queryClient } from "index";

interface IDeleteBlockModal {
  onClose: () => void;
  block_id: string;
  report_id: string;
}

export function DeleteBlockModal(props: IDeleteBlockModal) {
  const { onClose, block_id, report_id } = props;

  const { deleteBlock } = useDeleteBlock();
  const data = {
    block_ids: [block_id],
    id: report_id,
  };
  const handleDelete = () => {
    deleteBlock(data, {
      onError: (error, variables, context) => {
        toast.error(error?.message || "Error deletiing section", {
          position: "top-center",
          toastId: customId,
          autoClose: 2000,
          theme: "colored",
        });
      },
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: ["blocks", report_id] });
        toast.success("Section deleted successfully", {
          position: "top-center",
          toastId: customId,
          autoClose: 1000,
          theme: "colored",
        });
        onClose();
      },
    });
  };

  return (
    <div className={classNames("flex bg-[#FFF] flex-col rounded-2xl w-[300px]")}>
      <div className="flex flex-col p-5 gap-5 border-b-[1px] border-b-grey-100">
        <div className="flex justify-center items-center bg-error-50 mt-5 w-10 h-10 rounded-md">
          <img src={red_trash_icon} alt="delete section" className="h-5 w-5" />
        </div>
        <div className="flex flex-col gap-[5px]">
          <Typography variant="textmd" className="font-semibold text-shade-black">
            Delete Section
          </Typography>
          <Typography variant="textsm" className="text-grey-500 text-left !font-medium">
            Are you sure you want to delete this section? This action is permanant and section cannot be recovered
          </Typography>
        </div>
      </div>
      <div className="flex gap-2 pt-4 px-5 pb-5 border-t-[1px] border-t-grey-100">
        <Button type="button" title="Cancel" fullwidth color="info" onClick={() => onClose()} />
        <Button type="button" variant="filled" fullwidth color="error" title="Delete" onClick={handleDelete} />
      </div>{" "}
    </div>
  );
}
